import {
    REPORTS_PENDING,
    REPORTS_FAILED,
    REPORTS_DOWNLOADED,
    REPORTS_RESET,
    REPORT_FOCUS,
    REPORT_DELETING,
    REPORT_DELETED,
    REPORT_ITEM_POSTING,
    REPORT_ITEM_PICTURE_POSTING,
    REPORT_ITEM_DELETING,
    REPORT_DOWNLOADED, REPORT_ITEM_DOWNLOADED, REPORT_ITEM_DELETED, REPORT_EDITING
} from "./types";

export const INITIAL_STATE = {
    error: null,
    content: [],
    pending: false,
    sending: false,
    currentIndex: null,
    currentReport: null,
    itemSending: false
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case REPORTS_RESET:
            return INITIAL_STATE;
        case REPORT_EDITING:
            return {
                ...state,
                sending: true
            };
        case REPORT_DELETING:
            return {
                ...state,
                sending: true
            };
        case REPORT_DOWNLOADED:
            let reports = state.content;
            let pos = reports.map(function (e) {
                return e.id;
            }).indexOf(action.payload.id);
            reports[pos] = action.payload;
            return {
                ...state,
                sending: false,
                pending: false,
                content: reports
            };
        case REPORT_DELETED:
            let report = action.payload;
            let reportList = state.content;
            if (state.content !== null) {
                let isReport = (reportId) => {
                    return function (element) {
                        return element.id !== reportId;
                    }
                };
                reportList = state.content.filter(isReport(report.id));
            }
            let isFocusElement = report.id === state.currentReport.id;
            return {
                ...state,
                sending: false,
                content: reportList,
                currentIndex: (isFocusElement)? null: state.currentIndex,
                currentReport: (isFocusElement)? null: state.currentReport
            };
        case REPORTS_PENDING:
            return {
                ...state,
                pending: true
            };
        case REPORTS_DOWNLOADED:
            return {
                ...state,
                pending: false,
                sending: false,
                content: action.payload
            };
        case REPORT_FOCUS:
            return {
                ...state,
                error: null,
                currentIndex: state.content.findIndex(report => {
                    return report.id === action.payload.id
                }),
                currentReport: action.payload
            };
        case REPORTS_FAILED:
            return {
                ...state,
                pending: false,
                error: action.payload
            };
        case REPORT_ITEM_POSTING:
            return {
                ...state,
                itemSending: true
            };
        case REPORT_ITEM_DOWNLOADED:
            reports = {...state.content};
            let reportPos = reports.map(function (e) {return e.id;}).indexOf(action.payload.report.id);
            let itemPos = reports[reportPos].items.map(function (e) {return e.id;}).indexOf(action.payload.item.id);
            reports[reportPos].items[itemPos] = action.payload.item;
            return {
                ...state,
                itemSending: false,
                content: reports
            };
        case REPORT_ITEM_PICTURE_POSTING:
            return {
                ...state,
                itemSending: true
            };
        case REPORT_ITEM_DELETING:
            return {
                ...state,
                itemSending: true
            };
        case REPORT_ITEM_DELETED:
            reports = {...state.content};
            reportPos = reports.map(function (e) {return e.id;}).indexOf(action.payload.report.id);
            let reportItemId = (reportItemId) => {
                return function (element) {
                    return element.id !== reportItemId;
                }
            };
            reports[reportPos].items = reports[reportPos].items.filter(reportItemId(action.payload.item.id));
            return {
                ...state,
                itemSending: false,
                content: reports
            };
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/reports/reducers.js